var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"TheHeaderSkipForNow skip-link",attrs:{"to":{ name: 'sign-up-investment-experience' }}},[_vm._v("Skip for Now")])
}
var staticRenderFns = []

export { render, staticRenderFns }